<svg #svg [attr.width]="_options.width" [attr.height]="_options.height">
  <g [graphZoomableOf] = "svg">
    <g [link]="link" *ngFor="let link of links"></g>
    <g [node]="node" *ngFor="let node of nodes"
        [draggableNode]="node" [draggableInGraph]="graph"></g>
  </g>
</svg>
